export const SousDispositif = ['ProA', 'ProAFne'] as const

export type SousDispositif = (typeof SousDispositif)[number]

export const SousDispositifLibelle: Record<SousDispositif, string> = {
  ProA: 'Contrat PRO-A',
  ProAFne: 'Contrat PRO-A FNE',
} as const
